"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ResizeObserver = require('resize-observer-polyfill');
class AdFormBanner extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            bannerMounted: false,
            bannerLoaded: false
        };
    }
    componentDidMount() {
        window.addEventListener('scroll', this.mountBanner.bind(this));
        this.addBannerObserver();
        this.mountBanner();
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.mountBanner.bind(this));
    }
    render() {
        const { id, mobileId } = this.props;
        return (React.createElement("div", { className: `AdForm ${this.state.bannerLoaded ? 'active' : ''}` },
            this.state.bannerLoaded && (React.createElement("div", { className: "banner-title" },
                React.createElement("h5", null, "Annonse"))),
            React.createElement("div", { ref: (element) => { this.banner = element; } },
                id && (React.createElement("div", { id: id, className: "is-hidden-touch" })),
                mobileId && (React.createElement("div", { id: mobileId, className: "is-hidden-desktop" })))));
    }
    mountBanner() {
        const { id, mobileId } = this.props;
        if (this.state.bannerMounted || !this.isBannerInViewport()) {
            return;
        }
        if (id) {
            const script = document.createElement("script");
            script.setAttribute('data-adfscript', `adx.adform.net/adx/?mid=${id}`);
            document.getElementById(id).appendChild(script);
        }
        if (mobileId) {
            const mobileScript = document.createElement("script");
            mobileScript.setAttribute('data-adfscript', `adx.adform.net/adx/?mid=${mobileId}`);
            document.getElementById(mobileId).appendChild(mobileScript);
        }
        this.setState({ bannerMounted: true });
    }
    addBannerObserver() {
        const { id, mobileId } = this.props;
        const banner = document.getElementById(id);
        const mobileBanner = document.getElementById(mobileId);
        const ro = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { height } = entry.contentRect;
                if (height > 0) {
                    this.setState({ bannerLoaded: true });
                }
            }
        });
        if (banner) {
            ro.observe(banner);
        }
        if (mobileId) {
            ro.observe(mobileBanner);
        }
    }
    isBannerInViewport() {
        if (!this.banner)
            return false;
        const top = this.banner.getBoundingClientRect().top;
        return top >= 0 && top <= window.innerHeight;
    }
}
exports.AdFormBanner = AdFormBanner;
exports.default = AdFormBanner;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-adform/AdFormBanner.tsx